// 翻译映射表
const translations: Record<string, string> = {
  // 应用相关
  appName: '词匠工坊',
  appDescription: '快速提示词管理工具',
  
  // 导航相关
  promptManagement: '提示词管理',
  categoryManagement: '分类管理',
  globalSettings: '全局设置',
  googleAuth: 'Google 认证',
  
  // 提示词管理
  addPrompt: '添加提示词',
  editPrompt: '编辑提示词',
  deletePrompt: '删除提示词',
  promptTitle: '提示词标题',
  promptContent: '提示词内容',
  promptTags: '标签',
  promptCategory: '分类',
  promptNotes: '备注',
  
  // 分类管理
  addCategory: '添加分类',
  editCategory: '编辑分类',
  deleteCategory: '删除分类',
  categoryName: '分类名称',
  categoryDescription: '分类描述',
  categoryColor: '分类颜色',
  
  // 操作相关
  save: '保存',
  cancel: '取消',
  delete: '删除',
  edit: '编辑',
  confirm: '确认',
  search: '搜索',
  filter: '筛选',
  sort: '排序',
  export: '导出',
  import: '导入',
  
  // 状态相关
  enabled: '启用',
  disabled: '禁用',
  loading: '加载中...',
  saving: '保存中...',
  success: '成功',
  error: '错误',
  
  // 消息相关
  saveSuccess: '保存成功',
  deleteSuccess: '删除成功',
  operationFailed: '操作失败',
  noData: '暂无数据',
  confirmDelete: '确认删除？',
  
  
  // 键盘快捷键
  keyboardShortcut: '键盘快捷键',
  openPromptSelector: '打开提示词选择器',
  
  // 其他
  backToTop: '回到顶部',
  closeModal: '关闭弹窗',
  selectAll: '全选',
  deselectAll: '取消全选',
  
  // 错误信息
  invalidInput: '输入无效',
  networkError: '网络错误',
  storageError: '存储错误',
};

// 简单的 i18n 工具函数
export function t(key: string, substitutions?: string[]): string {
  try {
    let translation = translations[key] || key;
    
    // 如果有替换参数，进行字符串替换
    if (substitutions && substitutions.length > 0) {
      substitutions.forEach((sub, index) => {
        translation = translation.replace(`$${index + 1}`, sub);
      });
    }
    
    return translation;
  } catch (error) {
    console.warn(`Translation missing for key: ${key}`);
    return key;
  }
}

// 检查是否有翻译
export function hasTranslation(key: string): boolean {
  return key in translations;
}

// 添加翻译
export function addTranslation(key: string, value: string): void {
  translations[key] = value;
}

// 添加多个翻译
export function addTranslations(newTranslations: Record<string, string>): void {
  Object.assign(translations, newTranslations);
}
